import React, { Fragment, memo } from 'react';
import { motion } from 'framer-motion';
import { Section, fadeIn } from './ui/Section';
import { ArrowRight } from 'lucide-react';
export function MechanismSection() {
  return <Section className="bg-[#003366] text-white overflow-hidden relative" data-id="element-221">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-222"></div>

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-223">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} className="text-center mb-16" data-id="element-224">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-225">
            El "click": El Mecanismo Único
          </h2>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-226">
            La gente cree que fluidez = saber mucho. <br data-id="element-227" />
            Pero fluidez (para tu vida) ={' '}
            <span className="text-[#FF6600] font-bold" data-id="element-228">
              reaccionar sin traducir
            </span>
            .
          </p>
        </motion.div>

        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10" data-id="element-229">
          <p className="text-center text-lg mb-8 text-blue-100" data-id="element-230">
            Por eso este PDF está construido con un patrón fijo:
          </p>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-2" data-id="element-231">
            {['Escena', 'Intención', 'Frase Nativa', 'Respuesta Real', 'Variaciones'].map((step, idx, arr) => <Fragment key={step} data-id="element-232">
                <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: idx * 0.15
            }} viewport={{
              once: true
            }} className="bg-[#FF6600] text-white font-bold py-3 px-6 rounded-lg shadow-lg text-center w-full md:w-auto" data-id="element-233">
                  {step}
                </motion.div>
                {idx < arr.length - 1 && <ArrowRight className="text-white/50 w-6 h-6 rotate-90 md:rotate-0" data-id="element-234" />}
              </Fragment>)}
          </div>

          <div className="mt-12 text-center" data-id="element-235">
            <p className="text-xl md:text-2xl font-medium" data-id="element-236">
              No memorizas "inglés". <br data-id="element-237" />
              <span className="text-[#FF6600]" data-id="element-238">
                Memorizas respuestas que ya vienen armadas para el momento real.
              </span>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}